// Auto-populated address line under the WO Dates row. Reads the
// site selected in the form and renders a single clickable link
// that opens Google Maps in a new tab. Renders nothing if the site
// has no street/city/state/zip. Extracted from WorkOrderTab.jsx
// (Feb 2026, iter182).
export function WOAddressLink({ clientSites, siteId }) {
  const site = clientSites.find((s) => s.id === siteId);
  if (!site) return null;
  const parts = [site.address, site.city, site.state, site.zip].filter(Boolean);
  if (parts.length === 0) return null;
  const addr = parts.join(", ");
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addr)}`;
  return (
    <a
      href={mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="text-xs text-blue-600 hover:underline px-1 cursor-pointer"
      data-testid="wo-site-address-link"
    >
      {addr}
    </a>
  );
}
